import React, { useState } from 'react';

const Dictionary = () => {
  const [word, setWord] = useState('');
  const [meaning, setMeaning] = useState('');
  const [error, setError] = useState('');

  const fetchMeaning = async () => {
    setError(''); // Reset any previous errors
    try {
      const response = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`);
      if (!response.ok) {
        throw new Error('Word not found');
      }
      const data = await response.json();
      setMeaning(data[0]?.meanings[0]?.definitions[0]?.definition || 'No definition found');
    } catch (err) {
      setError(err.message);
      setMeaning('');
    }
  };

  const btnStyle = {
    margin: '5px',
    padding: '4px 8px',
    fontSize: '22px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer'
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Dictionary App</h1>
      <input
        type="text"
        value={word}
        onChange={(e) => setWord(e.target.value)}
        placeholder="Enter a word"
        style={{ padding: '10px', width: '200px' }}
      />
      <button onClick={fetchMeaning} style={btnStyle}>
        Get Meaning
      </button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {meaning && <p style={{ marginTop: '20px' }}><strong>Meaning:</strong> {meaning}</p>}
    </div>
  );
};

export default Dictionary;
